<template>
  <div style="position: relative;">
    <canvas ref="canvas" width="400" height="400"></canvas>
  </div>
</template>

<script>
import { Chart } from 'chart.js'

function withHorizontalIndexAxis (options) {
  const opts = options ? { ...options } : {}
  opts.indexAxis = 'y'
  return opts
}

export default {
  name: 'HorizontalBarChart',
  props: {
    chartdata: { type: Object, default: null },
    options:   { type: Object, default: null },
    /** optionale, nur an dieser Chart-Instanz registrierte Chart.js-Plugins (z.B. eigene afterDraw-Hooks) */
    plugins:   { type: Array, default: () => [] },
  },
  data () {
    return { chart: null }
  },
  mounted () {
    this.chart = new Chart(this.$refs.canvas, {
      type: 'bar',
      data: this.chartdata || { datasets: [] },
      options: withHorizontalIndexAxis(this.options),
      plugins: this.plugins,
    })
    this.$emit('set-chart', this.chart)
  },
  watch: {
    // Achtung: kein deep:true - Chart.js mutiert intern chart.options/chart.data
    // (z.B. _cache); bei deep-Watch fuehrt das zu einer Update-Loop. Konsumenten
    // weisen options/chartdata wholesale neu zu, daher reicht der Reference-Watch.
    chartdata (val) {
      if (this.chart) {
        this.chart.data = val || { datasets: [] }
        this.chart.update()
      }
    },
    options (val) {
      if (this.chart) {
        this.chart.options = withHorizontalIndexAxis(val)
        this.chart.update()
      }
    },
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
}
</script>

